import { ClientCartAction, ClientCartActionCartRef, SwarovskiOptikClientCart } from "@swo/storefront";
import { Either } from "fp-ts/es6/Either";
import { performCartAction } from "../perform-cart-action";

import { SwarovskiOptikErrorClientResponse } from "../../types";
import { CheckoutCustomerDataChangeAction } from "@swo/storefront";
import { CustomerDataChangePayload } from "../../cart-mutation-client";

export const customerDataChangeAction = (
  token: string,
  localeCode: string,
  segmentKey: string,
  _cartRef: ClientCartActionCartRef,
  data: CustomerDataChangePayload,
  baseUrl?: URL,
): Promise<Either<SwarovskiOptikErrorClientResponse, SwarovskiOptikClientCart>> => {
  const cartRef: ClientCartActionCartRef = {
    id: _cartRef.id,
    version: _cartRef.version,
  };

  const actionBody: CheckoutCustomerDataChangeAction = {
    tag: "checkout-customer-data-change",
    cartRef: cartRef,
    data: {
      email: data.email,

      title: data.title,
      firstName: data.firstName,
      lastName: data.lastName,

      buyAsACompany: data.buyAsCompany,
      companyName: data.companyName,
      vatNumber: data.vatNumber,
    },
  };

  return performCartAction(token, localeCode, segmentKey, baseUrl)(actionBody);
};
